import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'transformDate'
})
export class TransformDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {
    this.translate.use(localStorage.getItem('language') || 'si');
  }

  transform(
    value: string | undefined,
    pattern: string = 'short'
  ): string | null {
    if (value && pattern === 'medium') {
      const parts = value.split('-');

      const date = new Date(+parts[2].split(' ', 1), +parts[1] - 1, +parts[0]);
      return `${date.getDate()} ${this.translate.instant(
        date.toLocaleDateString('default', {
          month: 'long'
        })
      )}, ${date.getFullYear()}`;
    } else if (value && pattern == 'short') {
      const date = value.split('-').join('.');
      return date.concat('');
    } else if (value && pattern == 'messages') {
      // *** This pipe is only for chat (support) messages, since we receive the date and time UTC+00:00 ***
      let mDate = value.split(' ')[0]; // Extract date from the date and time
      let mTime = value.split(' ')[1]; // Extract time (hh:mm:ss) from the date and time

      let d = new Date( // Create UTC formatted date
        +mDate.split('-')[2], // Set year
        +mDate.split('-')[1] - 1, // Set month
        +mDate.split('-')[0], // Set day
        +mTime.split(':')[0], // Set hours
        +mTime.split(':')[1], // Set minutes
        +mTime.split(':')[2] // Set seconds
      );
      d.setHours(d.getHours() - new Date().getTimezoneOffset() / 60); // Extract hours from the date based on the Timezone difference

      const date =
        `${d.getDate().toString().padStart(2, '0')}.` + // Set day
        `${(d.getMonth() + 1).toString().padStart(2, '0')}.` + // Set month
        `${d.getFullYear()} ` + // Set year
        `${d.getHours().toString().padStart(2, '0')}:` + // Set hours
        `${d.getMinutes().toString().padStart(2, '0')}:` + // Set minutes
        `${d.getSeconds().toString().padStart(2, '0')}`; // Set seconds
      return date;
    } else if (pattern === 'picker') {
      if (value) {
        let date = new Date(value);
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let year = date.getFullYear();
        return `${day}.${month}.${year}`;
      } else {
        return `dd.mm.yyyy`;
      }
    }
    return null;
  }
}
